import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import EmptyList from "../../../components/ui/EmptyList";
import Workspace from "../../../components/workspace";
import { DeleteMemberDialog } from "./delete-member";
import Member from "./member";
import MemberForm from "./member-form";
import { SendSMSToMember } from "./send-sms-to-member";

const Members = ({ membershipLevels, membersList = [], setMembers }) => {
   const [selected, setSelected] = useState();
   const formModal = useDisclosure();
   const smsModal = useDisclosure();
   const deleteMemberDialog = useDisclosure();

   if (!membersList?.length) return <EmptyList message="Members would be listed here" />;
   return (
      <>
         <DeleteMemberDialog modal={deleteMemberDialog} memberId={selected?.id} setMembers={setMembers} />
         <SendSMSToMember modal={smsModal} member={selected} />
         <MemberForm membershipLevels={membershipLevels} id={selected?.id} modal={formModal} setSelected={setSelected} />
         <Workspace.ListWrapper>
            {membersList.map((_member, key) => (
               <Member
                  membershipLevels={membershipLevels}
                  member={_member}
                  key={key}
                  smsModal={smsModal}
                  deleteMemberDialog={deleteMemberDialog}
                  setSelected={setSelected}
                  formModal={formModal}
               />
            ))}
         </Workspace.ListWrapper>
      </>
   );
};

export { Members };
